import styled from 'styled-components'


const FooterStyle = styled.footer.attrs(props => ({ className: props.className }))`
    position: relative;
    padding:var(--sp8x) 0;

    &:before {
        content:"";
        position: absolute;
        top:0;
        left:var(--containerPadding);
        width: calc(100% - (2* var(--containerPadding)));
        height:1px;
        background-color: var(--grey);
    }

    .buttons-cont {
        button:last-child {
            margin-top:var(--spSize);
        }
    }

    .left-block {
        flex:1;
        margin-right: var(--sp16x);
        align-items: flex-start;

        .pages {
            flex-wrap: wrap;
            max-width: 520px;
            width: 100%;
    
            .page {
                width:50%;
                margin-bottom:var(--sp3x);
                white-space:nowrap;
            }
        }
    }


    .social {
        .block {
            justify-content: space-between;
        }

        a {
            i {
                font-size: var(--sp3x);
            }

            &:not(:last-child){
                margin-right:var(--sp3x);
            }
        }
        
        .footer-logo {
            align-items: flex-end;
            line-height: 1;
            margin-top:var(--sp8x);

            .logo {
                margin-left:var(--sp2x);
                
                width: 106px;
                padding-top:30px;
            }
        }
    }


    @media screen and (max-width:${(props) => props.theme.mediaQuery.TabletSize}){
        .left-block {
            margin-right:var(--sp8x);
            
            .pages {
                max-width: var(--sp40x);
            }
        }
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.TabletSizeS}){
        section {
            flex-direction :column ;
        }

        .left-block {
            margin-right:0;
            
            .pages {
                max-width: var(--sp36x);
            }
        }
        
        .social {
            flex-direction: row;
            width: 100%;
            justify-content: space-between;
            align-items: flex-end;
            max-width: unset;

            .footer-logo {
                margin-top: var(--sp2x);
            }

            a {

                i {
                    font-size: var(--sp3x);
                }
            }
        }
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.MobileSize}){
        padding:var(--sp3x) 0;
        section {
            flex-direction :column ;
        }


        .buttons-cont {
            flex-direction: row;

            button:last-child {
                margin-top:0;
                margin-left: auto;
            }
        }

        .ftr-btn {
            padding:var(--sp2x) var(--sp5x);
        }

        .left-block {
            flex-direction: column;

            .logo {
                position: absolute;
                bottom:var(--sp13x);
                left:var(--sp2x);
            }

            .pages {
                flex-wrap: wrap;
                max-width: unset;
                margin:var(--sp4x) 0 var(--spSize);

                .page {
                    width:50%;
                    margin-bottom: var(--sp3x);
                }
            }
        }

        .social {
            flex-direction: column;
            
            .block {
                align-self: flex-end;
                max-width: unset;
            }

            a {
                i {
                    font-size: var(--sp3x);
                }

                &:not(:last-child){
                    margin-right:var(--sp3x);
                }

                &:nth-child(even){
                    margin-left:0;
                }
            }

            .footer-logo {
                align-items: flex-end;
                line-height: 1;
                margin-top:0;
                width: 100%;
                justify-content: center;
                padding-top: var(--sp2x);
                margin-top:var(--sp4x);
                border-top:1px solid var(--grey);

                .logo {
                    margin-left:var(--sp2x);
                    
                    width: 106px;
                    padding-top:30px;
                }
            }
        }
    }
`
export default FooterStyle
